export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBxc4EsA.woff2";